(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_ndev-page-banner-button-assets"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'page-banner-video-popup';
    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(btnEl) {
      const controller = btnEl ? controllers.get(btnEl) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (btnEl) controllers.delete(btnEl);
    }

    function initOne(btnEl) {
      if (!btnEl || btnEl.dataset.actionType !== 'popup_video') return;

      destroyOne(btnEl);

      const dialogEl = btnEl.nextElementSibling;
      if (!dialogEl || dialogEl.tagName !== 'DIALOG') return;

      let isClosing = false;

      function closeWithAnimation() {
        if (isClosing || !dialogEl.open) return;
        isClosing = true;

        const videoEl = dialogEl.querySelector('video');
        if (videoEl) videoEl.pause();

        dialogEl.classList.add('closing');
        dialogEl.addEventListener('animationend', function handler(e) {
          if (e.target !== dialogEl) return;
          dialogEl.removeEventListener('animationend', handler);
          dialogEl.classList.remove('closing');
          isClosing = false;
          dialogEl.close();
        });
      }

      function handleBtnClick(e) {
        e.preventDefault();
        e.stopPropagation();
        dialogEl.showModal();

        const videoEl = dialogEl.querySelector('video');
        if (videoEl) {
          videoEl.muted = false;
          videoEl.play();
        }
      }

      function handleDialogClick(e) {
        const rect = dialogEl.getBoundingClientRect();
        if (e.clientY < rect.top || e.clientY > rect.bottom ||
            e.clientX < rect.left || e.clientX > rect.right) {
          closeWithAnimation();
        }
      }

      function handleHide(e) {
        e.preventDefault();
        closeWithAnimation();
      }

      function handleCancel(e) {
        e.preventDefault();
        closeWithAnimation();
      }

      btnEl.addEventListener('click', handleBtnClick);
      dialogEl.addEventListener('click', handleDialogClick);
      dialogEl.addEventListener('hide', handleHide);
      dialogEl.addEventListener('cancel', handleCancel);

      controllers.set(btnEl, {
        destroy: function () {
          btnEl.removeEventListener('click', handleBtnClick);
          dialogEl.removeEventListener('click', handleDialogClick);
          dialogEl.removeEventListener('hide', handleHide);
          dialogEl.removeEventListener('cancel', handleCancel);
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll('[data-action-type="popup_video"]');
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll('[data-action-type="popup_video"]');
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-countup"] && !Shopify.designMode) return;
  try {
    (function() {
  // 使用 WeakMap 跟踪每个容器的 observer 和动画状态，支持清理
  const elementState = new WeakMap();

  const parseNumberFromText = (text) => {
    const match = text.match(/[-+]?[0-9]*\.?[0-9]+/);
    return match ? parseFloat(match[0]) : null;
  };

  const formatNumber = (num, thousandsSeparator) => {
    const fixed = num.toFixed(0);
    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    return parts.join('.');
  };

  const easeOutQuart = t => 1 - (--t) * t * t * t;

  /**
   * 数字增长动画函数
   * @param {HTMLElement} el - 显示数字的元素
   * @param {number} start - 起始数字
   * @param {number} end - 结束数字
   * @param {number} duration - 动画时长（秒）
   * @param {string} thousandsSeparator - 千分位分隔符
   * @param {Function} onComplete - 动画完成回调
   */
  const animateCountUp = (el, start, end, duration, thousandsSeparator, onComplete) => {
    const startTime = performance.now();

    const update = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / (duration * 1000), 1);
      const easedProgress = easeOutQuart(progress);

      const current = start + (end - start) * easedProgress;
      el.textContent = formatNumber(current, thousandsSeparator);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = formatNumber(end, thousandsSeparator);
        if (onComplete) onComplete();
      }
    };

    requestAnimationFrame(update);
  };

  const processElement = (container) => {
    const text = container.textContent.trim();
    const number = parseNumberFromText(text);

    if (number === null) return;

    const duration = parseFloat(container.dataset.duration) || 2.5;
    const prefix = container.dataset.prefix || '';
    const suffix = container.dataset.suffix || '';
    const thousandsSeparator = container.dataset.thousandsSeparator || ',';

    // 预计算最终格式化的数字字符串
    const finalNumberText = formatNumber(number, thousandsSeparator);

    // 创建前缀 span
    const prefixSpan = document.createElement('span');
    prefixSpan.className = 'countup-prefix';
    prefixSpan.textContent = prefix;

    // 创建数字 span - 先设置为最终值以计算宽度
    const numberSpan = document.createElement('span');
    numberSpan.className = 'countup-number';
    numberSpan.textContent = finalNumberText;

    // 创建后缀 span
    const suffixSpan = document.createElement('span');
    suffixSpan.className = 'countup-suffix';
    suffixSpan.textContent = suffix;

    const textWithoutNumber = text.replace(/[-+]?[0-9]*\.?[0-9]+/, '');
    container.textContent = textWithoutNumber;
    container.appendChild(prefixSpan);
    container.appendChild(numberSpan);
    container.appendChild(suffixSpan);

    // 获取最终宽度并设置，避免动画过程中宽度变化
    const finalWidth = numberSpan.offsetWidth;
    numberSpan.style.width = finalWidth + 'px';

    // 重置为起始值，准备动画
    numberSpan.textContent = formatNumber(0, thousandsSeparator);

    // 标记动画是否正在播放
    let isAnimating = false;
    let hasAnimated = false;

    // 使用 Intersection Observer + checkVisibility 检测元素可见性
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const isVisible = entry.isIntersecting && container.checkVisibility();

        if (isVisible && !hasAnimated) {
          // 第一次进入视口且可见 - 播放动画
          hasAnimated = true;
          isAnimating = true;
          animateCountUp(numberSpan, 0, number, duration, thousandsSeparator, () => {
            isAnimating = false;
          });
        } else if (!isVisible && isAnimating) {
          // 动画播放中但元素变为不可见 - 重置状态，允许下次重新播放
          hasAnimated = false;
          isAnimating = false;
          numberSpan.textContent = formatNumber(0, thousandsSeparator);
        } else if (isVisible && hasAnimated && !isAnimating) {
          // 已经播放过但元素重新变为可见 - 重新播放
          isAnimating = true;
          animateCountUp(numberSpan, 0, number, duration, thousandsSeparator, () => {
            isAnimating = false;
          });
        } else if (!isVisible && hasAnimated) {
          // 不可见时重置数字为 0
          numberSpan.textContent = formatNumber(0, thousandsSeparator);
        }
      });
    }, observerOptions);

    observer.observe(container);

    // 保存 observer 和状态以便清理
    elementState.set(container, { observer, numberSpan });
  };

  function initCountups(scope) {
    const base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('.ndev-countup').forEach(processElement);
  }

  function destroyCountups(scope) {
    const base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('.ndev-countup').forEach((el) => {
      const state = elementState.get(el);
      if (state) {
        state.observer.disconnect();
        elementState.delete(el);
      }
    });
  }

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCountups();
    });
  } else {
    initCountups();
  }

  // Shopify Section 加载后重新初始化
  document.addEventListener('shopify:section:load', function(event) {
    initCountups(event && event.target ? event.target : null);
  });

  // Shopify Section 卸载时清理 observer，防止内存泄漏
  document.addEventListener('shopify:section:unload', function(event) {
    destroyCountups(event && event.target ? event.target : null);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__NDEV_DIALOG__';
    const DIALOG_SELECTOR = '[data-dialog]';
    const POSITION_ATTR = 'data-dialog-position';
    const POSITION_ATTR_MB = 'data-dialog-position-mb';

    if (window[GUARD]) return;

    const isClosingMap = new WeakMap();

    function getMatchMedia() {
      return window.matchMedia('(max-width: 1023px)');
    }

    function updatePosition(dialog) {
      const positionPc = dialog.getAttribute(POSITION_ATTR) || 'center';
      const positionMb = dialog.getAttribute(POSITION_ATTR_MB) || positionPc;
      const isMobile = getMatchMedia().matches;
      dialog.setAttribute(POSITION_ATTR, isMobile ? positionMb : positionPc);
    }

    function closeWithAnimation(dialog) {
      if (isClosingMap.get(dialog) || !dialog.open) return;
      isClosingMap.set(dialog, true);
      dialog.classList.add('closing');
      dialog.addEventListener('animationend', function handler(e) {
        if (e.target !== dialog) return;
        dialog.removeEventListener('animationend', handler);
        dialog.classList.remove('closing');
        isClosingMap.set(dialog, false);
        dialog.close();
      });
    }

    function openDialog(dialog) {
      if (!dialog) return;
      updatePosition(dialog);
      dialog.showModal();
    }

    function closeDialog(dialog) {
      if (!dialog || !dialog.open) return;
      closeWithAnimation(dialog);
    }

    function handleClick(dialog, e) {
      const rect = dialog.getBoundingClientRect();
      if (e.clientY < rect.top || e.clientY > rect.bottom ||
          e.clientX < rect.left || e.clientX > rect.right) {
        closeWithAnimation(dialog);
      }
    }

    function initDialog(dialog) {
      if (!dialog) return;

      updatePosition(dialog);

      const mm = getMatchMedia();
      const onMmChange = () => updatePosition(dialog);
      mm.addEventListener('change', onMmChange);

      const onDialogClick = (e) => handleClick(dialog, e);
      const onHide = (e) => { e.preventDefault(); closeWithAnimation(dialog); };
      const onCancel = (e) => { e.preventDefault(); closeWithAnimation(dialog); };

      dialog.addEventListener('click', onDialogClick);
      dialog.addEventListener('hide', onHide);
      dialog.addEventListener('cancel', onCancel);

      dialog.__dialogCleanup = () => {
        mm.removeEventListener('change', onMmChange);
        dialog.removeEventListener('click', onDialogClick);
        dialog.removeEventListener('hide', onHide);
        dialog.removeEventListener('cancel', onCancel);
        delete dialog.__dialogCleanup;
      };
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      base.querySelectorAll(DIALOG_SELECTOR).forEach(initDialog);
    }

    // 全局 API
    window[GUARD] = {
      open: openDialog,
      close: closeDialog,
      initAll: initAll,
    };

    // 事件委托：点击 [data-dialog-trigger] 时打开对应弹窗
    function handleTriggerClick(e) {
      const trigger = e.target.closest('[data-dialog-trigger]');
      if (!trigger) return;
      const targetId = trigger.getAttribute('data-dialog-trigger');
      const dialog = document.getElementById(targetId);
      if (!dialog) return;
      e.preventDefault();
      e.stopPropagation();
      openDialog(dialog);
    }

    document.addEventListener('click', handleTriggerClick);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const base = (event && event.target && event.target.querySelectorAll) ? event.target : null;
      if (!base) return;
      base.querySelectorAll(DIALOG_SELECTOR).forEach(dialog => {
        if (typeof dialog.__dialogCleanup === 'function') {
          dialog.__dialogCleanup();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-fade-in-out-scroll"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-ndev-fade-in-out-scroll]';
    const GUARD = '__ndevFadeInOutScroll';

    if (!window[GUARD]) {
      window[GUARD] = {};
    }

    function initAll(container) {
      if (typeof window.$narwal === 'undefined' || typeof window.$narwal.fadeInOut !== 'function') {
        return;
      }
      const base = container && container.querySelectorAll ? container : document;
      if (!base.querySelector(ROOT_SELECTOR)) {
        return;
      }
      window.$narwal.fadeInOut(ROOT_SELECTOR);
    }

    if (!window[GUARD].listenersBound) {
      window[GUARD].listenersBound = true;
      document.addEventListener('DOMContentLoaded', () => initAll());
      document.addEventListener('shopify:section:load', (event) => {
        initAll(event && event.target ? event.target : null);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-instagram-media-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ndevInstagramMediaCardPlayerInited) return;
    window.__ndevInstagramMediaCardPlayerInited = true;

    const mobileMQ = () => window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;

    function getVideoEl(card, index) {
      const list = card.querySelectorAll(`[node-name="video_${index}"]`);
      if (!list || list.length === 0) return null;

      // ndev-lazy-video 可能会输出 pc/mobile 两个节点
      if (list.length === 1) {
        const one = list[0];
        return one.tagName === 'VIDEO' ? one : (one.querySelector('video') || null);
      }

      const mobile = mobileMQ();
      const pick = Array.from(list).find((el) =>
        mobile ? el.classList.contains('mobile-done') : el.classList.contains('pc-done')
      );
      const node = pick || list[0];
      return node.tagName === 'VIDEO' ? node : (node.querySelector('video') || null);
    }

    function getBar(card, index) {
      return card.querySelector(`[node-name="bar_${index}"]`) || null;
    }

    function setBarProgress(bar, ratio) {
      if (!bar) return;
      const clamped = Math.max(0, Math.min(1, ratio));
      const total = 301.44;
      bar.style.strokeDashoffset = String(total * (1 - clamped));
    }

    function toggleIcons(card, index, isPlaying) {
      const playIcon = card.querySelector(`[node-name="play_${index}"]`);
      const pauseIcon = card.querySelector(`[node-name="pause_${index}"]`);
      if (playIcon) playIcon.classList.toggle('hide', isPlaying);
      if (pauseIcon) pauseIcon.classList.toggle('hide', !isPlaying);
    }

    function playVideo(card, index) {
      const video = getVideoEl(card, index);
      if (!video) return;
      card.classList.add('play');
      card.classList.add('off');
      toggleIcons(card, index, true);

      try {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
    }

    function pauseVideo(card, index) {
      const video = getVideoEl(card, index);
      if (!video) return;
      try {
        video.pause();
      } catch (_) {}
      card.classList.remove('play');
      card.classList.remove('off');
      toggleIcons(card, index, false);
    }

    function resetVideoUI(card, index) {
      const video = getVideoEl(card, index);
      const bar = getBar(card, index);
      card.classList.remove('play');
      card.classList.remove('off');
      toggleIcons(card, index, false);
      setBarProgress(bar, 0);
      if (video) {
        try {
          video.currentTime = 0;
        } catch (_) {}
      }
    }

    function playEmbed(card, index) {
      const codeEl = card.querySelector('[data-ndev-instagram-embed-code]');
      const wrap = card.querySelector('[data-ndev-instagram-embed]');
      if (!codeEl || !wrap) return;

      let code = '';
      try {
        code = JSON.parse(codeEl.textContent || '""') || '';
      } catch (_) {
        code = '';
      }
      if (!code) return;

      wrap.innerHTML = code;
      const iframe = wrap.querySelector('iframe');
      if (!iframe) return;
      const src = iframe.getAttribute('src') || '';
      const urlChar = src.includes('?') ? '&' : '?';
      iframe.setAttribute('src', `${src}${urlChar}autoplay=1&v=${Date.now()}`);

      card.classList.add('off');
    }

    // 使用事件委托，避免重复绑定 & 支持多实例
    document.addEventListener('click', (ev) => {
      const btn = ev.target && ev.target.closest && ev.target.closest('[node-name="play"]');
      if (!btn) return;

      const card = btn.closest('[data-ndev-instagram-media-card]');
      if (!card) return;

      ev.stopPropagation();
      const index = Number(btn.dataset.index || 0);

      if (btn.dataset.type === 'embed') {
        playEmbed(card, index);
        return;
      }

      // video toggle
      if (card.classList.contains('play')) pauseVideo(card, index);
      else playVideo(card, index);
    });

    // 进度条：用 timeupdate 同步即可
    document.addEventListener('timeupdate', (ev) => {
      const video = ev.target;
      if (!video || video.tagName !== 'VIDEO') return;

      const card = video.closest && video.closest('[data-ndev-instagram-media-card]');
      if (!card) return;

      const index = Number(card.querySelector('[node-name="play"]')?.dataset?.index || 0);
      const bar = getBar(card, index);
      const ratio = video.duration ? (video.currentTime / video.duration) : 0;
      setBarProgress(bar, ratio);
    }, true);

    // 播放结束时复位 UI（否则会停留在 pause icon）
    document.addEventListener('ended', (ev) => {
      const video = ev.target;
      if (!video || video.tagName !== 'VIDEO') return;
      const card = video.closest && video.closest('[data-ndev-instagram-media-card]');
      if (!card) return;
      const index = Number(card.querySelector('[node-name="play"]')?.dataset?.index || 0);
      resetVideoUI(card, index);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-klaviyo-api"] && !Shopify.designMode) return;
  try {
    (function() {
  // 防止重复初始化
  if (window.$klaviyo) {
    return;
  }

  /**
   * Klaviyo API 基础配置
   */
  const KLAVIYO_CONFIG = {
    baseUrl: 'https://a.klaviyo.com',
    revision: '2025-10-15',
    headers: {
      accept: 'application/json',
      revision: '2025-10-15',
      'content-type': 'application/json'
    }
  };

  /**
   * 通用的 Klaviyo API 请求处理函数
   * @param {string} url - 请求 URL
   * @param {Object} body - 请求体
   * @param {string} defaultErrorMessage - 默认错误消息
   * @returns {Promise<Object>} - 返回格式: { success: boolean, data?: Object, error?: string }
   */
  async function klaviyoRequest(url, body, defaultErrorMessage = 'Request failed') {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: KLAVIYO_CONFIG.headers,
        body: JSON.stringify(body)
      });

      // 获取响应文本，检查是否为空
      const responseText = await response.text();

      if (!response.ok) {
        // 尝试解析错误响应
        let errorData = {};
        try {
          if (responseText) {
            errorData = JSON.parse(responseText);
          }
        } catch (e) {
          // 如果无法解析 JSON，使用原始文本
          errorData = { message: responseText || `HTTP ${response.status}: ${response.statusText}` };
        }

        return {
          success: false,
          error: errorData.message || errorData.detail || errorData.errors?.[0]?.detail || defaultErrorMessage
        };
      }

      // 如果响应为空，返回空对象
      let data = {};
      if (responseText && responseText.trim() !== '') {
        // 尝试解析 JSON 响应
        try {
          data = JSON.parse(responseText);
        } catch (e) {
          // 如果无法解析，使用空对象（成功响应可能没有 body）
          data = {};
        }
      }

      return {
        success: true,
        data: data
      };
    } catch (error) {
      // 捕获所有未预期的错误
      return {
        success: false,
        error: error.message || 'An unexpected error occurred'
      };
    }
  }

  /**
   * 创建订阅
   * @param {Object} config - 配置对象
   * @param {string} config.email - 用户邮箱（必填）
   * @param {string} config.apiKey - Klaviyo API Key/Company ID（必填）
   * @param {string} config.listId - Klaviyo List ID（必填）
   * @param {Object} config.attributes - 额外的用户属性（可选）
   * @param {Object} config.ga4 - GA4 埋点配置（可选）
   * @param {string} config.ga4.module - 模块名称
   * @param {string} config.ga4.btn - 按钮名称
   * @returns {Promise<Object>} - 返回格式: { success: boolean, data?: Object, error?: string }
   */
  async function subscribe(config) {
    const { email, apiKey, listId, attributes = {}, ga4 = {} } = config;

    if (!email || !apiKey || !listId) {
      return {
        success: false,
        error: 'Klaviyo Subscribe: email, apiKey, and listId are required'
      };
    }

    const url = `${KLAVIYO_CONFIG.baseUrl}/client/subscriptions?company_id=${apiKey}`;
    const body = {
      data: {
        type: 'subscription',
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        },
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                ...attributes
              }
            }
          }
        }
      }
    };

    // 使用通用请求处理函数
    const result = await klaviyoRequest(url, body, 'Subscription failed');

    // 如果请求成功，触发事件
    if (result.success) {
      // 触发全局订阅成功事件
      if (window.$narwal?.emit) {
        window.$narwal.emit('KLAVIYO.SUBSCRIBE.SUCCESS', {
          id: listId,
          company_id: apiKey,
          email: email
        });
      }

      // 触发 GA4 订阅成功事件
      if (window.$narwal?.report && (ga4.module || ga4.btn)) {
        window.$narwal.report({
          event: 'subscribe',
          params: {
            page: 'self',
            btn: ga4.btn || 'subscribe',
            module: ga4.module || '',
            email: email,
            list_id: listId
          }
        });
      }
    }

    return result;
  }

  /**
   * 更新用户 Profile
   * @param {Object} config - 配置对象
   * @param {string} config.email - 用户邮箱（必填）
   * @param {string} config.apiKey - Klaviyo API Key/Company ID（必填）
   * @param {Object} config.properties - 要更新的属性（例如 { tag: 'TAG CES' }）
   * @param {Object} config.attributes - 额外的用户属性（可选，例如 first_name, last_name 等）
   * @returns {Promise<Object>} - 返回格式: { success: boolean, data?: Object, error?: string }
   */
  async function updateProfile(config) {
    const { email, apiKey, properties = {}, attributes = {} } = config;

    if (!email || !apiKey) {
      return {
        success: false,
        error: 'Klaviyo Update Profile: email and apiKey are required'
      };
    }

    const url = `${KLAVIYO_CONFIG.baseUrl}/client/profiles?company_id=${apiKey}`;
    const body = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          ...attributes
        }
      }
    };

    // 如果有 properties，添加到 attributes 中
    if (properties && Object.keys(properties).length > 0) {
      body.data.attributes.properties = properties;
    }

    // 使用通用请求处理函数
    return await klaviyoRequest(url, body, 'Update profile failed');
  }

  /**
   * 订阅并更新 Profile（组合操作）
   * @param {Object} config - 配置对象
   * @param {string} config.email - 用户邮箱（必填）
   * @param {string} config.apiKey - Klaviyo API Key/Company ID（必填）
   * @param {string} config.listId - Klaviyo List ID（必填）
   * @param {Object} config.properties - 要更新的属性（可选）
   * @param {Object} config.attributes - 额外的用户属性（可选）
   * @param {Object} config.ga4 - GA4 埋点配置（可选）
   * @param {string} config.ga4.module - 模块名称
   * @param {string} config.ga4.btn - 按钮名称
   * @returns {Promise<Object>} - 返回格式: { success: boolean, subscribe?: Object, update?: Object, error?: string }
   */
  async function subscribeAndUpdateProfile(config) {
    const { email, apiKey, listId, properties = {}, attributes = {}, ga4 = {} } = config;

    // 先订阅
    const subscribeResult = await subscribe({ email, apiKey, listId, attributes, ga4 });

    // 如果订阅失败，直接返回
    if (!subscribeResult.success) {
      return subscribeResult;
    }

    // 如果有 properties，再更新 profile
    if (properties && Object.keys(properties).length > 0) {
      const updateResult = await updateProfile({ email, apiKey, properties, attributes });

      // 如果更新失败，返回订阅成功但更新失败的结果
      if (!updateResult.success) {
        return {
          success: false,
          subscribe: subscribeResult,
          update: updateResult,
          error: updateResult.error
        };
      }

      return {
        success: true,
        subscribe: subscribeResult,
        update: updateResult
      };
    }

    return {
      success: true,
      subscribe: subscribeResult
    };
  }

  /**
   * 邮箱格式验证
   * @param {string} email - 要验证的邮箱
   * @returns {boolean} - 是否有效
   */
  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  /**
   * 解析 Klaviyo API 错误信息
   * @param {Error} error - 错误对象
   * @param {Object} messages - 自定义错误消息配置（可选）
   * @param {string} messages.alreadyRegistered - 邮箱已注册提示
   * @param {string} messages.invalid - 邮箱无效提示
   * @param {string} messages.default - 默认错误提示
   * @returns {string} - 用户友好的错误消息
   */
  function parseErrorMessage(error, messages = {}) {
    // 默认错误消息
    const defaultMessages = {
      alreadyRegistered: 'This email is already registered',
      invalid: 'This email is invalid',
      default: 'Subscription failed. Please try again.'
    };

    // 合并自定义消息
    const errorMessages = { ...defaultMessages, ...messages };

    // 如果没有错误消息，返回默认错误
    if (!error || !error.message) {
      return errorMessages.default;
    }

    const errorMsg = error.message.toLowerCase();

    // 检查是否为已存在的邮箱
    if (errorMsg.includes('already') || errorMsg.includes('exists')) {
      return errorMessages.alreadyRegistered;
    }

    // 检查是否为无效邮箱
    if (errorMsg.includes('invalid')) {
      return errorMessages.invalid;
    }

    // 返回原始错误消息或默认消息
    return error.message || errorMessages.default;
  }

  // 导出到全局
  window.$klaviyo = {
    subscribe,
    updateProfile,
    subscribeAndUpdateProfile,
    validateEmail,
    parseErrorMessage
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-media-video"] && !Shopify.designMode) return;
  try {
    (function () {
    var ROOT_SELECTOR = '[data-ndev-media]';
    var INIT_ATTR = 'data-ndev-media-init';

    function toBool(raw) {
      return raw === true || raw === 'true' || raw === '1';
    }

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
    }

    function getVisibleVideo(root) {
      var selector = isMobile() ? '.mb-done video.ndev-media__video' : '.pc-done video.ndev-media__video';
      var video = root.querySelector(selector);
      return video || root.querySelector('video.ndev-media__video');
    }

    function isInActiveTabPanel(root) {
      // 检查 ndev-cpi-tabs 面板
      var tabPanel = root.closest('.ndev-cpi-tabs__panel') || root.closest('.ndev-x30-sweep-tabs__image-panel');
      if (tabPanel) {
        return tabPanel.classList.contains('active');
      }
      return true;
    }

    function ensureInlineVideoAttrs(video) {
      if (!video) return;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function safePause(video, resetOnResume) {
      if (!video) return;
      try {
        video.pause();
      } catch (e) {}
      if (resetOnResume) {
        try {
          video.currentTime = 0;
        } catch (e) {}
      }
    }

    function safePlay(video) {
      if (!video) return;
      try {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR)) return;

      var allVideos = root.querySelectorAll('video');
      if (!allVideos.length) {
        root.setAttribute(INIT_ATTR, '1');
        return;
      }

      allVideos.forEach(ensureInlineVideoAttrs);

      var settingsScript = root.querySelector('script[data-ndev-media-settings]');
      if (!settingsScript) {
        root.setAttribute(INIT_ATTR, '1');
        return;
      }

      var settings = JSON.parse(settingsScript.textContent);
      var autoplayEnabled = toBool(settings.autoplay);
      var loopEnabled = toBool(settings.loop);
      var resetOnResume = toBool(settings.reset_on_resume);
      var threshold = parseFloat(settings.threshold);
      if (isNaN(threshold) || threshold < 0 || threshold > 1) threshold = 0.35;
      var toggleEvent = settings.toggle_event || null;

      allVideos.forEach(function (v) { v.loop = loopEnabled; });

      var inView = false;

      function sync() {
        var active = isInActiveTabPanel(root);
        var eligible = inView && active && !document.hidden;
        var video = getVisibleVideo(root);

        if (!eligible) {
          allVideos.forEach(function (v) { safePause(v, resetOnResume); });
          return;
        }

        allVideos.forEach(function (v) {
          if (v !== video) safePause(v, resetOnResume);
        });

        if (autoplayEnabled && video) {
          if (!video.muted) video.muted = true;
          safePlay(video);
        }
      }

      root.__ndevMediaSync = sync;

      var observer = null;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.target !== root) return;
              inView = !!entry.isIntersecting;
            });
            sync();
          },
          { root: null, rootMargin: '0px 0px 0px 0px', threshold }
        );
        observer.observe(root);
        root.__ndevMediaObserver = observer;
      } else {
        inView = true;
        sync();
      }

      var handleVisibility = function () {
        sync();
      };
      document.addEventListener('visibilitychange', handleVisibility);
      root.__ndevMediaVisibilityHandler = handleVisibility;

      var tabsRoot = root.closest('.ndev-closable-product-intro__tabs-block');
      if (tabsRoot && !tabsRoot.getAttribute('data-ndev-media-tabs-bound')) {
        tabsRoot.setAttribute('data-ndev-media-tabs-bound', '1');
        var titles = tabsRoot.querySelector('.ndev-cpi-tabs__titles');
        if (titles) {
          titles.addEventListener('click', function () {
            setTimeout(function () {
              initAll(tabsRoot);
              tabsRoot.querySelectorAll(ROOT_SELECTOR).forEach(function (r) {
                if (typeof r.__ndevMediaSync === 'function') r.__ndevMediaSync();
              });
            }, 0);
          });
        }
      }

      if (toggleEvent) {
        var handleToggle = function (e) {
          var video = getVisibleVideo(root);
          if (!video) return;
          var action = (e.detail && e.detail.action) || 'toggle';
          if (action === 'play') {
            if (!video.muted) video.muted = true;
            safePlay(video);
          } else if (action === 'pause') {
            safePause(video, resetOnResume);
          } else if (action === 'toggle') {
            if (video.paused) {
              if (!video.muted) video.muted = true;
              safePlay(video);
            } else {
              safePause(video, resetOnResume);
            }
          }
        };
        root.__ndevMediaToggleHandler = handleToggle;
        root.__ndevMediaToggleEvent = toggleEvent;
        document.addEventListener(toggleEvent, handleToggle);
      }

      root.setAttribute(INIT_ATTR, '1');
    }

    function destroyOne(root) {
      if (!root) return;

      if (root.__ndevMediaObserver) {
        try { root.__ndevMediaObserver.disconnect(); } catch (e) {}
        root.__ndevMediaObserver = null;
      }

      if (root.__ndevMediaVisibilityHandler) {
        try { document.removeEventListener('visibilitychange', root.__ndevMediaVisibilityHandler); } catch (e) {}
        root.__ndevMediaVisibilityHandler = null;
      }

      if (root.__ndevMediaToggleHandler && root.__ndevMediaToggleEvent) {
        try { document.removeEventListener(root.__ndevMediaToggleEvent, root.__ndevMediaToggleHandler); } catch (e) {}
        root.__ndevMediaToggleHandler = null;
        root.__ndevMediaToggleEvent = null;
      }

      root.__ndevMediaSync = null;
      root.removeAttribute(INIT_ATTR);
    }

    function initAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    function destroyAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e && e.target ? e.target : null);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      destroyAll(e && e.target ? e.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-retailer-links"] && !Shopify.designMode) return;
  try {
    (function() {
  document.querySelectorAll('.ndev-retailer-links__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var container = this.closest('.ndev-retailer-links');
      var list = container.querySelector('.ndev-retailer-links__list');
      var arrow = container.querySelector('.ndev-retailer-links__arrow');

      // 切换展开状态
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);

      // 切换列表显示
      if (list) {
        list.classList.toggle('hidden');
      }

      // 切换箭头旋转
      if (arrow) {
        arrow.classList.toggle('ndev-retailer-links__arrow--rotated');
      }
    });

    // 支持键盘 Enter/Space 触发
    trigger.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-scroll-fade-bg"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__ndevScrollFadeBg';
    const ROOT_ATTR = 'data-ndev-sfb';

    if (!window[GUARD]) {
      window[GUARD] = {
        instances: new WeakMap(),

        // 计算背景透明度
        calculateOpacity(progress, fadeStart, fadeEnd) {
          if (progress < fadeStart) return 0;
          if (progress > fadeEnd) return 1;
          return (progress - fadeStart) / (fadeEnd - fadeStart);
        },

        init(el) {
          const self = this;
          if (this.instances.has(el)) return;

          // 解析配置
          const fadeStart = parseFloat(el.dataset.ndevSfbFadeStart) || 0;
          const fadeEnd = parseFloat(el.dataset.ndevSfbFadeEnd) || 100;

          // 收集子元素
          const items = [];
          const itemEls = el.querySelectorAll('[data-ndev-sfb-item]');
          itemEls.forEach(function(itemEl) {
            items.push({
              el: itemEl,
              varName: itemEl.dataset.ndevSfbVar || '--ndev-sfb-opacity'
            });
          });

          const inst = {
            el: el,
            fadeStart: fadeStart,
            fadeEnd: fadeEnd,
            items: items,
            isActive: false
          };

          this.instances.set(el, inst);

          // 使用 $narwal.progress 监听进度
          $narwal.progress({ selectors: [el] }, function(progress) {
            inst.isActive = progress.enter;
            if (progress.enter) {
              // 计算 section 进度百分比
              const header = document.getElementById('site-header');
              const headerH = header ? header.offsetHeight : 0;
              const winH = window.innerHeight;
              const viewportHeight = winH - headerH;
              const rect = el.getBoundingClientRect();

              // 基于公式：((viewportH - sectionTop) / (sectionH + viewportH)) * 100
              const sectionProgress = Math.max(0, Math.min(100,
                ((viewportHeight - rect.top) / (rect.height + viewportHeight)) * 100
              ));

              const opacity = self.calculateOpacity(sectionProgress, inst.fadeStart, inst.fadeEnd);

              inst.items.forEach(function(item) {
                item.el.style.setProperty(item.varName, Math.max(0, Math.min(1, opacity)));
              });
            }
          });
        },

        destroy(el) {
          this.instances.delete(el);
        }
      };
    }

    const initElements = function() {
      var elements = document.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        if (!window[GUARD].instances.has(el)) {
          window[GUARD].init(el);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initElements);
    } else {
      initElements();
    }

    // Shopify 生命周期
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target;
      var elements = section.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        window[GUARD].init(el);
      });
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target;
      var elements = section.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        window[GUARD].destroy(el);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-scroll-fade-text"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__ndevScrollFadeText';
    const ROOT_ATTR = 'data-ndev-sft';

    if (!window[GUARD]) {
      window[GUARD] = {
        instances: new WeakMap(),
        rafId: null,
        pendingUpdates: new Set(),

        // 计算文字透明度
        calculateOpacity(el, config, viewportInfo) {
          const self = this;
          const { isSmallScreen, headerHeight, winH, imageH } = viewportInfo;
          const params = config.params;

          // 获取动态配置值 - 基于屏幕高度选择
          const clipTopPx = isSmallScreen ? params.clipTopMb : params.clipTopPc;
          // 如果 clipBottom 为 0，则使用图片高度作为默认值
          let clipBottomPx = isSmallScreen ? params.clipBottomMb : params.clipBottomPc;
          if (clipBottomPx === 0) clipBottomPx = imageH;

          const fadeTopPct = params.fadeTopPct;
          const fadeBottomPct = params.fadeBottomPct;

          // 简单动画模式：只判断元素是否在可视区域，返回 0 或 1
          if (!config.enableScrollAnim) {
            const rect = el.getBoundingClientRect();
            const elemTop = rect.top;
            const elemBottom = rect.bottom;

            const viewportWindowH = Math.max(0, winH - headerHeight - clipBottomPx);
            const limitClipTop = headerHeight + clipTopPx;
            const limitClipBottom = winH - clipBottomPx;

            // 底部裁剪区：完全隐藏
            if (elemBottom > limitClipBottom) return 0;
            // 顶部裁剪区：根据 isSticky 和 enableFadeOut 判断
            if (elemTop < limitClipTop) {
              return (config.isSticky || !config.enableFadeOut) ? 1 : 0;
            }
            // 在可视区域内：显示
            return 1;
          }

          // 完整动画模式
          const viewportWindowH = Math.max(0, winH - headerHeight - clipBottomPx);
          const limitClipTop = headerHeight + clipTopPx;
          const limitFadeTop = limitClipTop + (viewportWindowH * fadeTopPct / 100);
          const limitClipBottom = winH - clipBottomPx;
          const limitFadeBottom = limitClipBottom - (viewportWindowH * fadeBottomPct / 100);

          const rect = el.getBoundingClientRect();
          const elemTop = rect.top;
          const elemBottom = rect.bottom;

          // E. 底部裁剪区下方
          if (elemBottom > limitClipBottom) return 0;

          // D. 底部过渡区（渐显）
          if (elemBottom > limitFadeBottom) {
            const fadeRange = limitClipBottom - limitFadeBottom;
            if (fadeRange <= 0) return 1;
            return (limitClipBottom - elemBottom) / fadeRange;
          }

          // C. 中间安全区
          if (elemTop > limitFadeTop) return 1;

          // B. 顶部过渡区
          if (elemTop > limitClipTop) {
            if (config.isSticky || !config.enableFadeOut) return 1;
            const fadeRange = limitFadeTop - limitClipTop;
            if (fadeRange <= 0) return 1;
            return (elemTop - limitClipTop) / fadeRange;
          }

          // A. 顶部裁剪区
          return (config.isSticky || !config.enableFadeOut) ? 1 : 0;
        },

        loop() {
          const self = this;
          this.pendingUpdates.forEach(function(el) {
            const inst = self.instances.get(el);
            if (!inst || !inst.isActive) return;

            const header = document.getElementById('site-header');
            const headerH = header ? header.offsetHeight : 0;
            const winH = window.innerHeight;
            const winW = window.innerWidth;
            const isSmallScreen = (winW < 1024) || (winH <= 800);
            const imageH = isSmallScreen ? inst.config.heightMb : inst.config.heightPc;

            const viewportInfo = { isSmallScreen, headerHeight: headerH, winH, imageH };

            inst.items.forEach(function(item) {
              if (!item.el || item.enabled === false) return;
              const op = self.calculateOpacity(item.el, inst.config, viewportInfo);
              item.el.style.setProperty(item.varName, Math.max(0, Math.min(1, op)));
            });
          });

          this.pendingUpdates.clear();
          this.rafId = null;
        },

        schedule(el) {
          this.pendingUpdates.add(el);
          if (!this.rafId) {
            const self = this;
            this.rafId = requestAnimationFrame(function() { self.loop(); });
          }
        },

        init(el) {
          const self = this;
          if (this.instances.has(el)) return;

          // 解析配置
          const config = {
            params: {
              clipTopPc: parseFloat(el.dataset.ndevSftClipTopPc) || 0,
              clipTopMb: parseFloat(el.dataset.ndevSftClipTopMb) || 0,
              fadeTopPct: parseFloat(el.dataset.ndevSftFadeTopPct) || 20,
              clipBottomPc: parseFloat(el.dataset.ndevSftClipBottomPc) || 0,
              clipBottomMb: parseFloat(el.dataset.ndevSftClipBottomMb) || 0,
              fadeBottomPct: parseFloat(el.dataset.ndevSftFadeBottomPct) || 20
            },
            heightPc: parseFloat(el.dataset.ndevSftHeightPc) || 600,
            heightMb: parseFloat(el.dataset.ndevSftHeightMb) || 400,
            isSticky: el.hasAttribute('data-ndev-sft-sticky'),
            enableFadeOut: el.hasAttribute('data-ndev-sft-fade-out'),
            enableScrollAnim: true
          };

          // 检查简单动画模式
          if (el.hasAttribute('data-ndev-sft-simple')) {
            config.enableScrollAnim = false;
          }

          // 收集子元素
          const items = [];
          const itemEls = el.querySelectorAll('[data-ndev-sft-item]');
          itemEls.forEach(function(itemEl) {
            items.push({
              el: itemEl,
              varName: itemEl.dataset.ndevSftVar || '--ndev-sft-opacity',
              enabled: itemEl.dataset.ndevSftEnabled !== 'false'
            });
          });

          const inst = {
            el: el,
            config: config,
            items: items,
            isActive: true
          };

          this.instances.set(el, inst);

          // 监听滚动
          $narwal.on('scroll', function() {
            self.schedule(el);
          });

          // 监听 resize
          $narwal.on('resize', function() {
            self.schedule(el);
          });

          // 初始更新
          this.schedule(el);
        },

        destroy(el) {
          this.instances.delete(el);
          this.pendingUpdates.delete(el);
        }
      };
    }

    const initElements = function() {
      var elements = document.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        if (!window[GUARD].instances.has(el)) {
          window[GUARD].init(el);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initElements);
    } else {
      initElements();
    }

    // Shopify 生命周期
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target;
      var elements = section.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        window[GUARD].init(el);
      });
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target;
      var elements = section.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        window[GUARD].destroy(el);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-scroll-frame"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__ndevScrollFrame';
    const ROOT_ATTR = 'data-ndev-sf';

    if (!window[GUARD]) {
      window[GUARD] = {
        instances: new WeakMap(),
        rafId: null,
        pendingFps: new Map(),
        pendingProgress: new Map(),

        loop() {
          const self = this;
          const entries = Array.from(this.pendingFps.entries());
          this.pendingFps.clear();

          entries.forEach(function(entry) {
            const el = entry[0];
            const fps = entry[1];
            const inst = self.instances.get(el);
            if (inst && inst.isActive && inst.render) {
              const progress = Math.max(0, Math.min(1, fps));
              const rendered = inst.render(progress);
              if (rendered !== false && !inst.posterHidden) {
                self.hidePoster(inst);
                inst.posterHidden = true;
                if (!inst.readyEmitted) {
                  inst.readyEmitted = true;
                  el.dispatchEvent(new CustomEvent('ndev-sf-ready', {
                    detail: { duration: inst.duration },
                    bubbles: true
                  }));
                }
              }
              self.emitProgress(el, progress, inst);
            }
          });

          this.rafId = null;
        },

        emitProgress(el, progress, inst) {
          const key = el;
          const lastProgress = this.pendingProgress.get(key) || -1;
          const currentProgress = Math.round(progress * 1000);

          if (currentProgress !== lastProgress) {
            this.pendingProgress.set(key, currentProgress);
            el.dispatchEvent(new CustomEvent('ndev-sf-progress', {
              detail: {
                progress: progress,
                percent: Math.round(progress * 100),
                duration: inst.duration || 0
              },
              bubbles: true
            }));
          }
        },

        schedule(el, fps) {
          this.pendingFps.set(el, fps);
          if (!this.rafId) {
            const self = this;
            this.rafId = requestAnimationFrame(function() { self.loop(); });
          }
        },

        hidePoster(inst) {
          const posters = inst.canvasWrap.querySelectorAll('.ndev-sf__poster');
          posters.forEach(function(p) { p.classList.add('hidden'); });
        },

        init(options) {
          const self = this;
          const el = options.el;
          const pcUrl = options.pcUrl;
          const mbUrl = options.mbUrl;
          const fps = options.fps;
          const canvasWrap = el.querySelector('[data-ndev-sf-canvas]');
          const canvas = canvasWrap ? canvasWrap.querySelector('canvas') : null;
          if (!canvas) return;

          const vhPerSecond = parseFloat(el.dataset.ndevSfVhPerSecond) || 100;
          const pcDuration = parseFloat(canvasWrap.dataset.ndevSfPcDuration) || 0;
          const mbDuration = parseFloat(canvasWrap.dataset.ndevSfMbDuration) || pcDuration;
          const frameInterval = parseInt(canvasWrap.dataset.ndevSfFrameInterval, 10) || 40;

          const duration = $narwal.isMobile ? mbDuration : pcDuration;
          const heightVh = Math.ceil(duration * vhPerSecond);
          el.style.height = heightVh + 'vh';

          const inst = {
            el: el,
            canvas: canvas,
            canvasWrap: canvasWrap,
            ctx: canvas.getContext('2d'),
            fps: fps,
            frameInterval: frameInterval,
            render: null,
            isActive: false,
            posterHidden: false,
            duration: duration,
            readyEmitted: false
          };

          this.instances.set(el, inst);

          const url = $narwal.isMobile ? (mbUrl || pcUrl) : pcUrl;
          if (url) {
            $narwal.load('fps', function(videoFps) {
              inst.render = videoFps.initVideo({
                el: inst.el,
                canvas: inst.canvas,
                ctx: inst.ctx,
                url: url,
                mobileUrl: mbUrl,
                desktopUrl: pcUrl,
                frameInterval: frameInterval
              });
            });
          }

          // 启动滚动监听
          $narwal.progress({ selectors: [el] }, function(progress) {
            inst.isActive = progress.enter;
            if (progress.enter) {
              self.schedule(el, progress.visualFps);
            }
          });
        }
      };
    }

    const initElements = function() {
      var elements = document.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        if (!window[GUARD].instances.has(el)) {
          var wrap = el.querySelector('[data-ndev-sf-canvas]');
          if (wrap) {
            window[GUARD].init({
              el: el,
              pcUrl: wrap.dataset.ndevSfPcUrl || '',
              mbUrl: wrap.dataset.ndevSfMbUrl || '',
              fps: parseInt(wrap.dataset.ndevSfFps, 10) || 30
            });
          }
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initElements);
    } else {
      initElements();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-share-social-media-list"] && !Shopify.designMode) return;
  try {
    (function() {
    // 检测触摸屏设备和减少动画偏好
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    var motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // 在触摸屏或减少动画模式下跳过特效
    if (isTouch || motionReduced) return;

    // 为所有分享按钮添加 data-ndev-magnet 属性（默认磁吸强度 10）
    var buttons = document.querySelectorAll('.ndev-share-list .share-item');

    buttons.forEach(function(btn) {
      // 跳过已初始化的按钮
      if (btn.hasAttribute('data-ndev-magnet-initialized')) return;

      btn.setAttribute('data-ndev-magnet', btn.getAttribute('data-ndev-magnet') || '10');
      btn.setAttribute('data-ndev-magnet-initialized', 'true');

      btn.addEventListener('mousemove', function(e) {
        var magnet = parseInt(this.getAttribute('data-ndev-magnet')) || 10;
        if (magnet === 0) return;

        var rect = this.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width - 0.5) * magnet;
        var y = ((e.clientY - rect.top) / rect.height - 0.5) * magnet;

        this.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        this.style.transition = 'transform 0.15s ease-out';
      });

      btn.addEventListener('mouseleave', function() {
        this.style.transform = 'translate(0, 0)';
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-sticky-prev-cover"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-ndev-spc]';
    const PADDING_BOTTOM_ATTR = 'data-ndev-spc-pad';
    const INIT_ATTR = 'data-ndev-spc-init';
    const PREV_CLASS = 'ndev-sticky-prev-cover-prev--sticky';
    const SELF_CLASS = 'ndev-sticky-prev-cover-self--stack';
    const GUARD = '__ndevStickyPrevCover';

    if (!window[GUARD]) {
      window[GUARD] = { instances: new WeakMap() };
    }
    const { instances } = window[GUARD];

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;

      const selfWrap = root.closest('.shopify-section');
      if (!selfWrap) return;

      const prevWrap = selfWrap.previousElementSibling;
      if (!prevWrap || !(prevWrap instanceof HTMLElement)) return;

      const padRaw = root.getAttribute(PADDING_BOTTOM_ATTR);
      const paddingBottom =
        padRaw && String(padRaw).trim() !== '' ? String(padRaw).trim() : '50vh';
      prevWrap.style.paddingBottom = paddingBottom;

      function updateStickyTop() {
        const vh = window.innerHeight;
        const padPx = parseFloat(getComputedStyle(prevWrap).paddingBottom) || 0;
        const hFull = prevWrap.offsetHeight;
        const baseTopPx = vh - (hFull - padPx);
        prevWrap.style.top = `calc(${baseTopPx}px - ${paddingBottom})`;
      }

      prevWrap.classList.add(PREV_CLASS);
      selfWrap.classList.add(SELF_CLASS);
      updateStickyTop();

      window.addEventListener('resize', updateStickyTop, { passive: true });

      let ro;
      if (typeof ResizeObserver !== 'undefined') {
        ro = new ResizeObserver(() => updateStickyTop());
        ro.observe(prevWrap);
      }

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, () => {
        window.removeEventListener('resize', updateStickyTop);
        if (ro) ro.disconnect();
        prevWrap.classList.remove(PREV_CLASS);
        prevWrap.style.top = '';
        prevWrap.style.paddingBottom = '';
        selfWrap.classList.remove(SELF_CLASS);
        root.removeAttribute(INIT_ATTR);
      });
    }

    function destroyOne(root) {
      const teardown = instances.get(root);
      if (!teardown) return;
      teardown();
      instances.delete(root);
    }

    function initAll(container) {
      (container || document).querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    if (!window[GUARD].listenersBound) {
      window[GUARD].listenersBound = true;
      document.addEventListener('DOMContentLoaded', () => initAll());
      document.addEventListener('shopify:section:load', (event) => initAll(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-video-seek"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__ndevVideoSeek';
    const ROOT_ATTR = 'data-ndev-video-seek';

    if (!window[GUARD]) {
      window[GUARD] = {
        instances: new WeakMap(),
        rafId: null,
        pendingProgress: new Map(),

        loop() {
          const self = this;
          const entries = Array.from(this.pendingProgress.entries());

          entries.forEach(function(entry) {
            const el = entry[0];
            const progress = entry[1];
            const inst = self.instances.get(el);

            if (inst && inst.isActive && inst.video && inst.ready) {
              self.seekTo(inst, progress);
              self.emitProgress(el, progress, inst);
            }
          });

          this.pendingProgress.clear();
          this.rafId = null;
        },

        seekTo(inst, progress) {
          const { video, duration } = inst;
          if (!video) return;

          const targetTime = progress * duration;
          const timeDiff = Math.abs(video.currentTime - targetTime);

          // 只有当差异大于阈值且不在 seeking 状态时才 seek
          if (timeDiff > 0.05 && !video.seeking) {
            video.currentTime = targetTime;
          }
        },

        emitProgress(el, progress, inst) {
          const key = el;
          const lastProgress = this.pendingProgress.get(key) || -1;
          const currentProgress = Math.round(progress * 1000);

          if (currentProgress !== lastProgress) {
            this.pendingProgress.set(key, currentProgress);
            el.dispatchEvent(new CustomEvent('ndev-video-seek-progress', {
              detail: {
                progress: progress,
                percent: Math.round(progress * 100),
                currentTime: progress * inst.duration,
                duration: inst.duration
              },
              bubbles: true
            }));
          }
        },

        schedule(el, progress) {
          this.pendingProgress.set(el, progress);
          if (!this.rafId) {
            const self = this;
            this.rafId = requestAnimationFrame(function() { self.loop(); });
          }
        },

        init(options) {
          const self = this;
          const el = options.el;
          const wrap = el.querySelector('[data-ndev-vseek-wrap]');
          if (!wrap) return;

          const vhPerSecond = parseFloat(el.dataset.ndevVideoSeekVhPerSecond) || 100;
          const pcDuration = parseFloat(wrap.dataset.ndevVseekPcDuration) || 0;
          const mbDuration = parseFloat(wrap.dataset.ndevVseekMbDuration) || pcDuration;

          const isMobile = $narwal.isMobile;
          const duration = isMobile ? mbDuration : pcDuration;

          // 设置容器高度
          const heightVh = Math.ceil(duration * vhPerSecond);
          el.style.height = heightVh + 'vh';

          const inst = {
            el: el,
            wrap: wrap,
            video: null,
            duration: duration,
            ready: false,
            isActive: false
          };

          this.instances.set(el, inst);

          // 获取对应的 video 元素
          const videoClass = isMobile ? '.ndev-vseek__video.mb-done' : '.ndev-vseek__video.pc-done';
          const video = wrap.querySelector(videoClass);

          if (video) {
            function onReady() {
              inst.duration = video.duration;
              inst.ready = true;
              inst.video = video;

              // 触发 ready 事件
              el.dispatchEvent(new CustomEvent('ndev-video-seek-ready', {
                detail: { duration: inst.duration },
                bubbles: true
              }));

              // 初始 seek 到第一帧
              video.currentTime = 0;
            }

            // 处理竞态：视频可能已加载完成
            if (video.readyState >= 1) {
              onReady();
            } else {
              video.addEventListener('loadedmetadata', onReady);
            }

            video.addEventListener('error', function(e) {
              console.error('[ndev-vseek] Video error:', e);
            });
          }

          // 启动滚动监听
          $narwal.progress({ selectors: [el] }, function(progress) {
            inst.isActive = progress.enter;
            if (progress.enter) {
              self.schedule(el, progress.visualFps);
            }
          });
        }
      };
    }

    const initElements = function() {
      var elements = document.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        if (!window[GUARD].instances.has(el)) {
          var wrap = el.querySelector('[data-ndev-vseek-wrap]');
          if (wrap) {
            window[GUARD].init({ el: el });
          }
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initElements);
    } else {
      initElements();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-youtube-media-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ndevYoutubeMediaCardPlayerInited) return;
    window.__ndevYoutubeMediaCardPlayerInited = true;

    const mobileMQ = () => window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;

    function getVideoEl(card, index) {
      const list = card.querySelectorAll(`[node-name="video_${index}"]`);
      if (!list || list.length === 0) return null;

      if (list.length === 1) {
        const one = list[0];
        return one.tagName === 'VIDEO' ? one : (one.querySelector('video') || null);
      }

      const mobile = mobileMQ();
      const pick = Array.from(list).find((el) =>
        mobile ? el.classList.contains('mobile-done') : el.classList.contains('pc-done')
      );
      const node = pick || list[0];
      return node.tagName === 'VIDEO' ? node : (node.querySelector('video') || null);
    }

    function getBar(card, index) {
      return card.querySelector(`[node-name="bar_${index}"]`) || null;
    }

    function setBarProgress(bar, ratio) {
      if (!bar) return;
      const clamped = Math.max(0, Math.min(1, ratio));
      const total = 301.44;
      bar.style.strokeDashoffset = String(total * (1 - clamped));
    }

    function toggleIcons(card, index, isPlaying) {
      const playIcon = card.querySelector(`[node-name="play_${index}"]`);
      const pauseIcon = card.querySelector(`[node-name="pause_${index}"]`);
      if (playIcon) playIcon.classList.toggle('hide', isPlaying);
      if (pauseIcon) pauseIcon.classList.toggle('hide', !isPlaying);
    }

    function playVideo(card, index) {
      const video = getVideoEl(card, index);
      if (!video) return;
      card.classList.add('off');
      toggleIcons(card, index, true);

      try {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
    }

    function pauseVideo(card, index) {
      const video = getVideoEl(card, index);
      if (!video) return;
      try {
        video.pause();
      } catch (_) {}
      card.classList.remove('off');
      toggleIcons(card, index, false);
    }

    function playEmbed(card, index) {
      const codeEl = card.querySelector('[data-ndev-youtube-embed-code]');
      const wrap = card.querySelector('[data-ndev-youtube-embed]');
      if (!codeEl || !wrap) return;

      let code = '';
      try {
        code = JSON.parse(codeEl.textContent || '""') || '';
      } catch (_) {
        code = '';
      }
      if (!code) return;

      wrap.innerHTML = code;
      const iframe = wrap.querySelector('iframe');
      if (!iframe) return;
      const rawSrc = iframe.getAttribute('src') || iframe.getAttribute('data-src') || '';
      if (!rawSrc) return;
      iframe.setAttribute('allow', iframe.getAttribute('allow') || 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.removeAttribute('data-src');

      const urlChar = rawSrc.includes('?') ? '&' : '?';
      iframe.setAttribute('src', `${rawSrc}${urlChar}autoplay=1&v=${Date.now()}`);
      card.classList.add('off');
    }

    document.addEventListener('click', (ev) => {
      const btn = ev.target && ev.target.closest && ev.target.closest('[node-name="play"]');
      if (!btn) return;

      const card = btn.closest('[data-ndev-youtube-media-card]');
      if (!card) return;

      ev.stopPropagation();
      const index = Number(btn.dataset.index || 0);

      if (btn.dataset.type === 'embed') {
        playEmbed(card, index);
        return;
      }

      // video toggle
      const video = getVideoEl(card, index);
      if (!video) return;
      if (!video.paused) pauseVideo(card, index);
      else playVideo(card, index);
    });

    document.addEventListener('timeupdate', (ev) => {
      const video = ev.target;
      if (!video || video.tagName !== 'VIDEO') return;

      const card = video.closest && video.closest('[data-ndev-youtube-media-card]');
      if (!card) return;

      const index = Number(card.querySelector('[node-name="play"]')?.dataset?.index || 0);
      const bar = getBar(card, index);
      const ratio = video.duration ? (video.currentTime / video.duration) : 0;
      setBarProgress(bar, ratio);
    }, true);

    // 播放结束时复位 UI
    document.addEventListener('ended', (ev) => {
      const video = ev.target;
      if (!video || video.tagName !== 'VIDEO') return;
      const card = video.closest && video.closest('[data-ndev-youtube-media-card]');
      if (!card) return;
      const index = Number(card.querySelector('[node-name="play"]')?.dataset?.index || 0);
      const bar = getBar(card, index);
      card.classList.remove('off');
      toggleIcons(card, index, false);
      setBarProgress(bar, 0);
      try {
        video.currentTime = 0;
      } catch (_) {}
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
